var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['button-about', 'center', {'active': _vm.isActive}]},[_c('span',{staticClass:"button-txt"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }